import type { Copy } from "../types";

export const id: Copy = {
    seo: {
      title: "Kalkulator Usia Mobil | cek usia kendaraan berdasarkan tahun dan bulan",
      description:
        "Cek usia kendaraan yang tepat dari tahun produksi dan bulan opsional. Lihat tahun, bulan, hari, total hari, dan momen penting dalam satu alat yang rapi.",
      keywords: [
        "kalkulator usia mobil",
        "kalkulator usia kendaraan",
        "cek tahun produksi mobil",
        "cek bulan produksi kendaraan",
        "umur mobil saya",
        "cek usia mobil berdasarkan tahun",
        "cek usia kendaraan",
        "kalkulator usia RC",
        "cek usia mobil berdasarkan bulan",
        "kalkulator tanggal kendaraan",
        "mParivahan alternatif",
        "Parivahan alternatif",
        "kalkulator usia kendaraan RTO",
        "cek usia registrasi mobil",
        "usia registrasi kendaraan",
      ],
      faq: [
        {
          question: "Apa fungsi kalkulator ini?",
          answer:
            "Kalkulator ini menghitung usia kendaraan secara tepat dari tahun produksi yang dipilih dan bulan opsional, lalu menampilkan tahun, bulan, hari, dan informasi momen penting.",
        },
        {
          question: "Kenapa ada bulan opsional?",
          answer:
            "Pengaturan bulan memberikan perhitungan usia yang lebih tepat. Jika Anda tidak memilih bulan, sistem akan menggunakan Januari dari tahun yang dipilih.",
        },
        {
          question: "Bisakah saya memilih tahun atau bulan di masa depan?",
          answer:
            "Tidak. Tahun di masa depan diblokir, dan bulan di masa depan dinonaktifkan jika tahun yang dipilih adalah tahun berjalan.",
        },
      ],
    },
    headerTagline: "Utilitas kendaraan",
    headerTitle: "Kalkulator Usia Mobil",
    reset: "Atur ulang",
    switchToLight: "Pindah ke mode terang",
    switchToDark: "Pindah ke mode gelap",
    languageLabel: "Bahasa",
    languageEnglish: "Bahasa Inggris",
    languageHindi: "Bahasa Hindi",
    heroEyebrow: "Usia mobil, jelas",
    heroTitle: "Alat tanggal yang rapi untuk usia kendaraan.",
    heroDescription:
      "Pilih tahun produksi. Tambahkan bulan hanya jika Anda ingin hasil yang lebih presisi.",
    yearSelectLabel: "Tahun produksi",
    monthSelectLabel: "Bulan produksi",
    includeMonthLabel: "Sertakan bulan tertentu untuk presisi lebih tinggi",
    includeMonthNote: "Jika bulan tidak disertakan, Januari akan digunakan dalam perhitungan.",
    yearOnlyBadge: "Hanya tahun",
    yearMonthBadge: "Tahun + bulan",
    yearPlaceholder: "Pilih tahun",
    monthPlaceholder: "Pilih bulan",
    inputTitle: "Tahun produksi",
    inputLabel: "Tahun produksi",
    blockedDateNote: "Tahun di masa depan diblokir.",
    result: "Hasil",
    vehicleAgeLead: "Kendaraan Anda",
    asOfToday: "Per hari ini",
    years: "Tahun",
    months: "Bulan",
    days: "Hari",
    totalDays: (count) => `${count.toLocaleString("en-IN")} jumlah hari`,
    ageLabels: { almostNew: "Hampir baru", modern: "Modern", mature: "Matang", classic: "Klasik" },
    estimatedValue: {
      high: "Potensi jual kembali tinggi",
      healthy: "Nilai tetap terjaga",
      moderate: "Penyusutan sedang",
      collector: "Minat kolektor bisa meningkat",
    },
    maintenanceTitle: "Perawatan",
    maintenance: {
      routine: "Servis rutin dan perawatan OEM",
      watch: "Perhatikan rem, cairan, dan ban",
      plan: "Rencanakan komponen aus dan inspeksi",
      specialized: "Perawatan khusus menjadi lebih penting",
    },
    registrationTitle: "Registrasi",
    registration: {
      collector: "Di beberapa wilayah bisa mendapat perlakuan kendaraan koleksi",
      classic: "Di beberapa wilayah registrasi mobil klasik dapat berlaku",
      standard: "Harapkan perpanjangan standar dan pemeriksaan wilayah",
      regular: "Biasanya berlaku registrasi biasa",
    },
    upcomingMilestoneTitle: "Momen penting berikutnya",
    milestoneTimelineTitle: "Linimasa momen penting",
    milestoneRemaining: ({ label, days }) => `${label} dalam ${days.toLocaleString("id-ID")} hari`,
    reached: "Tercapai",
    upcoming: "Berikutnya",
    allMilestonesReachedTitle: "Semua momen penting yang disenaraikan sudah tercapai",
    allMilestonesReachedBody: "Kendaraan ini sudah melewati rentang momen penting yang ditampilkan di aplikasi.",
    copySummary: "Salin ringkasan",
    shareResult: "Bagikan hasil",
    resetMessage: "Kalkulator diatur ulang",
    summaryCopied: "Ringkasan disalin ke papan klip",
    clipboardFailed: "Gagal mengakses papan klip",
    emptyTitle: "Pilih tahun produksi untuk melihat rincian lengkap",
    emptyDescription:
      "Setelah tahun dipilih, Anda akan melihat usia tepat, total hari, catatan perawatan, status klasik, dan waktu momen penting.",
    shareTitle: "Kalkulator Usia Mobil",
    summary: ({ label, years, months, days, asOf }) =>
      `Mobil saya diproduksi pada ${label} dan usianya ${years} tahun, ${months} bulan, ${days} hari per ${asOf}.`,
    milestones: {
      1: { label: "Tahun pertama", note: "Bermanfaat untuk garansi dan rencana servis." },
      3: { label: "Tiga tahun", note: "Tahap umum untuk jual kembali dan perubahan nilai." },
      5: { label: "Lima tahun", note: "Waktu yang baik untuk meninjau anggaran perawatan." },
      10: { label: "Sepuluh tahun", note: "Komponen yang menua perlu perhatian lebih." },
      15: { label: "Lima belas tahun", note: "Di banyak wilayah mulai mendapat perlakuan klasik." },
      25: { label: "Dua puluh lima tahun", note: "Menarik untuk kolektor dan impor di beberapa pasar." },
    },
  };
